import React from "react";

const ScoreCircle = ({ score }) => {
  const circleRadius = 20;
  const circleCircumference = 2 * Math.PI * circleRadius;
  const strokeDashoffset =
    score > 0
      ? circleCircumference - (score / 100) * circleCircumference
      : circleCircumference;

  const getColor = () => {
    if (score >= 85) return "text-green-500"; // Best Match
    if (score >= 75) return "text-lime-500"; // Good Fit
    if (score >= 60) return "text-yellow"; // Average Fit
    if (score >= 50) return "text-orange-800"; // Fair Fit
    return "text-red-500"; // Not a Fit
  };

  const colorClass = getColor();

  const getTextColor = () => {
    if (score >= 85) return "#22C55E"; // Best Match
    if (score >= 75) return "#84CC16"; // Good Fit
    if (score >= 60) return "#d97706b3"; // Average Fit
    if (score >= 50) return "#9a3412"; // Fair Fit
    return "#EF4444"; // Not a Fit
  };

  const textColor = getTextColor();

  return (
    <div className="flex justify-center items-center">
      <svg width="100" height="100">
        <g transform="rotate(-90 50 50)">
          {/* Background circle */}
          <circle
            className="text-gray-200"
            cx="50"
            cy="50"
            r={circleRadius}
            fill="transparent"
            stroke="currentColor"
            strokeWidth="4"
          />
          {/* Progress circle (Only visible when score > 0) */}
          <circle
            className={score > 0 ? colorClass : "text-gray-300"}
            cx="50"
            cy="50"
            r={circleRadius}
            fill="transparent"
            stroke="currentColor"
            strokeWidth="4"
            strokeDasharray={circleCircumference}
            strokeDashoffset={strokeDashoffset}
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />
        </g>
        {/* Score text */}
        <text
          x="51%"
          y="52%"
          dominantBaseline="middle"
          textAnchor="middle"
          style={{
            fill: score > 0 ? textColor : "#9CA3AF",
            fontSize: "0.8rem",
            fontWeight: "bold",
          }}
        >
          {score ? `${score}%` : "0%"}
        </text>
      </svg>
    </div>
  );
};

export default ScoreCircle;
